import { useParams } from 'react-router-dom';
import { Navbar } from '../../components';
import './styles.css';
import { FormCarrera } from './components/form-carrera/FormCarrera';
import { FormCurso } from './components/form-curso/FormCurso';
import { FormTaller } from './components/form-taller/FormTaller';
import { FormReintegro } from './components/form-reintegro/FormReintegro';
import { FormSimplificado} from './components/form-simplificado/FormSimplificado';
import { FormSinglePayment } from './components/form-single-payment/FormSinglePayment';

export const HomeStudentsPage = () => {
  const { typeForm } = useParams();

  const renderForm = () => {
    switch (typeForm) {
      case 'registro_carrera':
        return <FormCarrera />;
      case 'registro_curso':
        return <FormCurso />;
      case 'registro_taller':
        return <FormTaller />;
      case 'registro_reintegro':
        return <FormReintegro />;
      case 'registro_simplificado':
        return <FormSimplificado />;
      case 'single_payment':
        return <FormSinglePayment />;
      default:
        return (
          <div className='w-full max-w-2xl bg-white border border-gray-300 rounded-lg shadow-sm p-8 text-center'>
            <h1 className='text-2xl font-semibold text-gray-900'>
              No encontramos la pagina solicitada
            </h1>
            <p className='mt-4 text-gray-700'>
              Revisa el enlace recibido o contáctanos si necesitas ayuda para
              acceder a tu formulario.
            </p>
          </div>
        );
    }
  };

  return (
    <>
      <Navbar />
      <div
        className="pt-20 pb-20 sm:pt-[7rem] sm:pb-[7rem] px-4 sm:px-6 lg:px-10 w-full h-auto flex justify-center"
        style={{ background: '#F9F9F9' }}
      >
        {renderForm()}
      </div>
    </>
  );
};
